(function() {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider
      .state('anuarioSimplificado', {
        url: "/anuarioSimplificado",
        templateUrl: 'module/corregedoria/relatorioAnual/simplificado/relatorio.html',
        controller: 'RelatorioAnualSimplificadoController',
        controllerAs: 'vm',
      })
      .state('anuarioCompleto', {
        url: "/anuarioCompleto",
        templateUrl: 'module/corregedoria/relatorioAnual/completo/relatorio.html',
        controller: 'RelatorioAnualCompletoController',
        controllerAs: 'vm',
      });
  }

})();
